// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { MessagesInner } from "./MessagesInner";
import {
  MessagesInnerFromJSON,
  MessagesInnerFromJSONTyped,
  MessagesInnerToJSON,
  MessagesInnerToJSONTyped,
} from "./MessagesInner";
import type { User } from "./User";
import { UserFromJSON, UserFromJSONTyped, UserToJSON, UserToJSONTyped } from "./User";
import type { Point } from "./Point";
import { PointFromJSON, PointFromJSONTyped, PointToJSON, PointToJSONTyped } from "./Point";

/**
 *
 * @export
 * @interface CommentRead
 */
export interface CommentRead {
  /**
   *
   */
  id: string;
  /**
   *
   */
  publicationId: string;
  /**
   *
   */
  location: Point;
  /**
   *
   */
  creator: User;
  /**
   *
   */
  messages: Array<MessagesInner>;
  /**
   *
   */
  createdAt: Date;
  /**
   *
   */
  updatedAt: Date;
  /**
   *
   */
  apiKeyId: string | null;
  /**
   *
   */
  resolved: boolean;
}

/**
 * Check if a given object implements the CommentRead interface.
 */
export function instanceOfCommentRead(value: object): value is CommentRead {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (
    (!("publicationId" in (value as Record<string, any>)) &&
      !("publication_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["publicationId"] === undefined &&
      (value as Record<string, any>)["publication_id"] === undefined)
  )
    return false;
  if (!("location" in value) || value["location"] === undefined) return false;
  if (!("creator" in value) || value["creator"] === undefined) return false;
  if (!("messages" in value) || value["messages"] === undefined) return false;
  if (
    (!("createdAt" in (value as Record<string, any>)) &&
      !("created_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["createdAt"] === undefined &&
      (value as Record<string, any>)["created_at"] === undefined)
  )
    return false;
  if (
    (!("updatedAt" in (value as Record<string, any>)) &&
      !("updated_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["updatedAt"] === undefined &&
      (value as Record<string, any>)["updated_at"] === undefined)
  )
    return false;
  if (
    (!("apiKeyId" in (value as Record<string, any>)) &&
      !("api_key_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["apiKeyId"] === undefined &&
      (value as Record<string, any>)["api_key_id"] === undefined)
  )
    return false;
  if (!("resolved" in value) || value["resolved"] === undefined) return false;
  return true;
}

export function CommentReadFromJSON(json: any): CommentRead {
  return CommentReadFromJSONTyped(json, false);
}

export function CommentReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommentRead {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    publicationId: json["publication_id"],
    location: PointFromJSON(json["location"]),
    creator: UserFromJSON(json["creator"]),
    messages: (json["messages"] as Array<any>).map(MessagesInnerFromJSON),
    createdAt: json["created_at"] == null ? json["created_at"] : parseDateTime(json["created_at"]),
    updatedAt: json["updated_at"] == null ? json["updated_at"] : parseDateTime(json["updated_at"]),
    apiKeyId: json["api_key_id"],
    resolved: json["resolved"],
  };
}

export function CommentReadToJSON(json: any): CommentRead {
  return CommentReadToJSONTyped(json, false);
}

export function CommentReadToJSONTyped(
  value?: CommentRead | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    publication_id: value["publicationId"],
    location: PointToJSON(value["location"]),
    creator: UserToJSON(value["creator"]),
    messages: (value["messages"] as Array<any>).map(MessagesInnerToJSON),
    created_at:
      value["createdAt"] == null ? value["createdAt"] : serializeDateTime(value["createdAt"]),
    updated_at:
      value["updatedAt"] == null ? value["updatedAt"] : serializeDateTime(value["updatedAt"]),
    api_key_id: value["apiKeyId"],
    resolved: value["resolved"],
  };
}
